import styled from "styled-components"
import { theme } from "../../styles/theme"
import { Section_History_Targets } from "../../components/Section/History/Targets"
import { Section_History_StatCharts } from "../../components/Section/History/StatCharts"
import { ChangeEventHandler, MouseEventHandler, useMemo, useState } from "react"
import { usePreventHtmlScroll } from "../../hook"
import { useUpdateSt } from "../../api/st"

export const HistoryComparePage = () => {
  usePreventHtmlScroll()
  const
  [target, setTarget] = useState({
    part: {id: 0, name: ""},
    group: {id: 0, name: ""},
    device: {id: 0, name: ""},
  }),
  apiTarget = useMemo(() => {
    return {
      partName: target.part.name,
      groupName: target.group.name,
      driveNumber: target.device.name,
    }
  }, [target]),
  session = useMemo(() => {
    const _session = JSON.parse(sessionStorage.getItem("HIS_COM_SESSION") ?? "0")

    const dates = {
      s1: "",
      e1: "",
      s2: "",
      e2: "",
    }

    if (_session) {
      dates.s1 = _session.s1 ?? ""
      dates.e1 = _session.e1 ?? ""
      dates.s2 = _session.s2 ?? ""
      dates.e2 = _session.e2 ?? ""
    }

    return {dates}
  }, []),
  [dates, setDates] = useState(session.dates),
  {mutateAsync: updateSt} = useUpdateSt()

  const onEvent = (e: any) => {
    try {
      const {event, type, data} = e
      switch (type) {
        case "listTarget": {
          return setTarget(data.target)
        }
      }

    } catch (e: any) {
      console.error(`onEvent > `, e)
    }
  }

  const onClick: MouseEventHandler = async e => {
    try {
      const {target} = e
      if (target instanceof HTMLElement) {
        const
        {dataset} = target,
        {onclick} = dataset
        if (onclick) switch (onclick) {
          case "updateSt": {
            const res = await updateSt(apiTarget.driveNumber)
            if (res?.status != 200) alert("요청 실패")
            else alert("요청 성공")
            return
          }
        }
      }

    } catch (e: any) {
      console.error(`Section_History_StatCharts.onClick > `, e)
    }
  }

  const onChange: ChangeEventHandler = e => {
    const input = e.target
    if (input instanceof HTMLInputElement) {
      const {type, name, value} = input
      if (type && name) switch (type) {
        case "date": {
          if (["s1", "e1", "s2", "e2"].includes(name)) {
            const _session = JSON.parse(sessionStorage.getItem("HIS_COM_SESSION") ?? "0") || {}
            _session[name] = value
            sessionStorage.setItem("HIS_COM_SESSION", JSON.stringify(_session))
            setDates(prev => ({...prev, [name]: value}))
          }
        }
      }
    }
  }

  return (
    <StyledPage>
      <Section_History_Targets onEvent={onEvent} />

      <section className="contents">
        <header onClick={onClick}>
          <div className="period">
            <label>시작</label>
            <input type="date" name="s1" value={dates.s1} onChange={onChange} />
            <label>종료</label>
            <input type="date" name="e1" value={dates.e1} onChange={onChange} />
            {!!apiTarget.driveNumber && <button data-onclick="updateSt">최신 데이터 노출</button>}
          </div>
          <div className="period">
            <label>시작</label>
            <input type="date" name="s2" value={dates.s2} onChange={onChange} />
            <label>종료</label>
            <input type="date" name="e2" value={dates.e2} onChange={onChange} />
          </div>
        </header>
        <div>
          <Section_History_StatCharts apiTarget={apiTarget} startDate={dates.s1} endDate={dates.e1} />
          <Section_History_StatCharts apiTarget={apiTarget} startDate={dates.s2} endDate={dates.e2} />
        </div>
      </section>
    </StyledPage>
  )
}

export const StyledPage = styled.div`
  flex: 1;
  background-color: ${theme.colors.black_bg2};
  
  & > .contents {
    position: fixed;
    bottom: 0;
    right: 0;
    width: calc(100% - 400px);
    height: calc(100% - 65px);
    display: grid;
    color: ${theme.colors.white};

    & > header {
      display: grid;
      grid-auto-flow: column;
      padding: 14px;
      gap: 14px;

      & > div {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;

        & > label {
          flex-shrink: 0;
        }
        & > input {
          font-size: 18px;
        }
        & > button {
          white-space: nowrap;
          border: 1px solid ${theme.colors.green};
          background-color: transparent;
          height: 34px;
          padding: 0 10px;
          border-radius: 6px;
          &:hover {
            background-color: ${theme.colors.green};
          }
          &:active {
            background-color: transparent;
          }
        }
      }
    }
    & > div {
      display: grid;
      overflow: auto;
      grid-auto-flow: column;
      grid-template-columns: repeat(2, 1fr);
      gap: 14px;
      padding: 14px;
    }
  }
`